module.exports = __webpack_public_path__ + "media/src/images/system-logo-cbf5418f609528f93316cb67be79f7f5.png";